// extracted by mini-css-extract-plugin
var _1 = "useSpellCorrector-module__indicator--lhMKc";
export { _1 as "indicator" }
